import React from 'react';
import {
  PointRelaisQuery,
  RelaisMainInfoFragment
} from '../../../../../../../graphql/generated/graphql';
import { useDispatch, useSelector } from 'react-redux';
import { updatePointRelais } from '../../../../../../../store/actions/client.actions';
import { getSelectedPointRelais } from '../../../../../../../store/selectors/client.selectors';
import LeafletMap from '../../../../../../molecules/Map';
import { FlatIcon } from '../../../../../../atoms/Icons/FlatIcon';
import useStyle from './displayRelais.style';

interface DisplayRelaisProps {
  pointRelais: PointRelaisQuery['pointRelais'];
}

const DisplayRelais = ({ pointRelais }: DisplayRelaisProps) => {
  const dispatch = useDispatch();
  const selectedRelais = useSelector(getSelectedPointRelais);
  const classes = useStyle();

  if (!pointRelais || pointRelais.length < 1)
    return (
      <h2>
        Aucun point relais pour ce code postal...{' '}
        <span role="img" aria-label="oups">
          😕
        </span>
      </h2>
    );

  const getRelaisName = relais =>
    relais.nom +
    ' ' +
    relais.adresse1 +
    ' ' +
    relais.codePostal +
    ' ' +
    relais.localite;
  const handleClick = (relais: RelaisMainInfoFragment) => {
    dispatch(updatePointRelais(relais));
  };
  return (
    <div>
      <div className={classes.container}>
        {selectedRelais.nompointrelais && (
          <p className={classes.selectedLine}>
            Vous avez sélectionné : {selectedRelais.fullName}{' '}
          </p>
        )}
        <LeafletMap
          markers={pointRelais.map(relais => ({
            lat: parseFloat(relais.coordGeolocalisationLatitude),
            long: parseFloat(relais.coordGeolocalisationLongitude),
            name: getRelaisName(relais),
            data: relais
          }))}
          handleClick={handleClick}
          selectedMarker={selectedRelais}
        />
        <div>
          {pointRelais.map(relais => (
            <div
              className={classes.relaisLine}
              key={relais.identifiant}
              onClick={() => handleClick(relais)}
            >
              <p>{getRelaisName(relais)}</p>
              {relais.identifiant === selectedRelais.relaisid && (
                <FlatIcon icon={'Tick'} size={'small'} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DisplayRelais;
